import backgroundData from './background-data.json'
import stickerData from './sticker-data.json'
import { MediaCollection, SeratoStock, MediaItem } from './types'

const backgrounds = backgroundData as SeratoStock
const stickers = stickerData as SeratoStock

export type { MediaCollection, SeratoStock, MediaItem } from './types'
export interface CollectionPageResponse {
  pageItems: MediaItem[]
  totalResults: number
}

export function fetchBackgroundCollections (): MediaCollection[] {
  return backgrounds.collections
}

export function fetchStickerCollections (): MediaCollection[] {
  return stickers.collections
}

export function fetchBackgroundsByCollectionId (id: string, page: number, itemsPerPage: number): CollectionPageResponse {
  const foundCollection = backgrounds.collections.find(collection => collection.id === id)
  if (!foundCollection) {
    return {
      pageItems: [],
      totalResults: 0
    }
  }
  const startIndex = (page - 1) * itemsPerPage
  const endIndex = Math.min((page * itemsPerPage), foundCollection.items.length)
  const pageItems = foundCollection.items.slice(startIndex, endIndex)
  return {
    pageItems,
    totalResults: foundCollection.items.length
  }
}

export function fetchStickersByCollectionId (id: string, page: number, itemsPerPage: number): CollectionPageResponse {
  const foundCollection = stickers.collections.find(collection => collection.id === id)
  if (!foundCollection) {
    return {
      pageItems: [],
      totalResults: 0
    }
  }
  const startIndex = (page - 1) * itemsPerPage
  const endIndex = Math.min((page * itemsPerPage), foundCollection.items.length)
  const pageItems = foundCollection.items.slice(startIndex, endIndex)
  return {
    pageItems,
    totalResults: foundCollection.items.length
  }
}
